import React from 'react'
import './App.css';
import Cgpa from './components/CalculateCgpa';


function App() {
  return (
    <div>
      <Cgpa/>
    </div>
  );
}

export default App;
